class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = 0;
    this.ticking = false;
    this.visible = false;
    this.button = this.querySelector('button');
    this.hideFromPagination = false;
    this.container = null;

    this.handleScrollBound = () => this.handleScroll();
    this.handleClickBound = () => this.scrollToTop();
    this.handleKeydownBound = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.scrollToTop();
      }
    };
    this.handlePaginationScrollBound = () => {
      this.hideFromPagination = true;
      this.hide();
      setTimeout(() => {
        this.hideFromPagination = false;
      }, 1500);
    };
  }

  connectedCallback() {
    if (!this.button) return;

    this.container = this.parentElement;

    this.button.addEventListener('click', this.handleClickBound);
    this.button.addEventListener('keydown', this.handleKeydownBound);
    window.addEventListener('scroll', this.handleScrollBound, { passive: true });

    this.setupPaginationListeners();

    this.checkScrollPosition();
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.checkScrollPosition();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  checkScrollPosition() {
    const currentScrollY = window.scrollY;
    const scrollingUp = currentScrollY < this.lastScrollY;
    const scrollThreshold = window.innerHeight * 2;

    const containerBottom = this.container
      ? this.container.getBoundingClientRect().bottom
      : Infinity;
    const viewportExceedsContainer = containerBottom < window.innerHeight;

    if (this.hideFromPagination || viewportExceedsContainer) {
      this.hide();
    } else if (scrollingUp && currentScrollY > scrollThreshold) {
      this.show();
    } else if (!scrollingUp || currentScrollY <= scrollThreshold) {
      this.hide();
    }

    this.lastScrollY = currentScrollY;
  }

  show() {
    if (!this.visible) {
      this.visible = true;
      this.setAttribute('visible', '');
    }
  }

  hide() {
    if (this.visible) {
      this.visible = false;
      this.removeAttribute('visible');
    }
  }

  setupPaginationListeners() {
    window.addEventListener('pagination:scroll-start', this.handlePaginationScrollBound);
  }

  scrollToTop() {
    window.dispatchEvent(new Event('back-to-top:clicked'));
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScrollBound);
    window.removeEventListener('pagination:scroll-start', this.handlePaginationScrollBound);
    if (this.button) {
      this.button.removeEventListener('click', this.handleClickBound);
      this.button.removeEventListener('keydown', this.handleKeydownBound);
    }
  }
}

customElements.define('back-to-top', BackToTop);
